import type { ActionContext } from 'vuex'

import type { ActionClass, IndexJobDTO, IndexState } from '../../../models'
import type { IndexJobService, IndexJobServiceFeedParams } from '../../../services/interfaces'

import { CONTAINER } from '../../../config/inversify.config'

import { TYPES } from '../../../config/inversify.types'

export class ReindexFeedAction implements ActionClass {
  static execute(
    this: void,
    context: ActionContext<IndexState, unknown>,
    params: IndexJobServiceFeedParams,
  ): Promise<IndexJobDTO> {
    const service = CONTAINER.get<IndexJobService>(TYPES.IndexJobService)
    return service.reindex(params)
  }
}
